import { useState } from 'react';
import { useDataFetch, Indicator } from '../providers/DataFetch.provider';

const useDataFetchIndicator = (): [
  [boolean, string?, Indicator?, boolean?],
  (isFetching: boolean, msg?: string, indicator?: Indicator, isDataFetchingSticky?: boolean) => void,
] => {
  const { isDataFetching, loadingMessage, indicator, setDataFetchingInfo } = useDataFetch();
  const [isDataFetchingSticky, setIsDataFetchingSticky] = useState<boolean | undefined>(undefined);

  const setDataFetchingInfoWithSticky = (
    isFetching: boolean,
    msg: string = '',
    indicatorFunc: Indicator = 'fullScreen',
    isDataFetchingStickyFunc?: boolean,
  ) => {
    if (isDataFetchingStickyFunc !== undefined) {
      setIsDataFetchingSticky(isDataFetchingStickyFunc);
    }
    setDataFetchingInfo(isFetching, msg, indicatorFunc);
  };

  return [[isDataFetching, loadingMessage, indicator, isDataFetchingSticky], setDataFetchingInfoWithSticky];
};

export default useDataFetchIndicator;
